import { patchRequest } from '@/core';
import { trips } from '@/requests';

export default async function updateTripsRequest(patch) {
	let url = trips.getPath();
	let response = await patchRequest(url, {}, patch);
	return response;
}
